import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ie-noti-bar',
  templateUrl: './ie-noti-bar.component.html',
  styleUrls: ['./ie-noti-bar.component.scss'],
})
export class IENotiBarComponent implements OnInit {
  @HostBinding('class.is-active') readonly isIE: boolean;

  @Input() fixedPosition: 'top' | 'bottom';

  constructor() {
    this.isIE = /(MSIE 10|MSIE 9|rv:11.0|Edge\/\d.)/i.test(navigator.userAgent);
  }

  @HostBinding('class.is-fixed')
  get isFixed() {
    return this.fixedPosition != null;
  }

  ngOnInit(): void {}
}
